import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

import { DealerOrganization, PropertyOrganization } from "src/common/types";
import { useKy } from "src/common/ky";

type AdminPortalPropertyDetailsResponse = {
  property: PropertyOrganization;
  dealer: DealerOrganization;
};

const getPropertyDetailsQueryKey = (propertyOrganizationId: string) => {
  return ["ADMIN_PORTAL_PROPERTY_DETAILS_QUERY", propertyOrganizationId];
};

export const useGetPropertyOrganizationDetails = () => {
  const ky = useKy();
  const { propertyOrganizationId } = useParams() as {
    propertyOrganizationId: string;
  };

  return useQuery<AdminPortalPropertyDetailsResponse>(
    getPropertyDetailsQueryKey(propertyOrganizationId),
    () =>
      ky
        .get(`property-organizations/${propertyOrganizationId}`)
        .json<AdminPortalPropertyDetailsResponse>()
  );
};
